import { render, staticRenderFns } from "./Road.vue?vue&type=template&id=4ee06a52&scoped=true"
import script from "./Road.vue?vue&type=script&lang=js"
export * from "./Road.vue?vue&type=script&lang=js"
import style0 from "./Road.vue?vue&type=style&index=0&id=4ee06a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee06a52",
  null
  
)

export default component.exports